export const KMS_RESPONSE_PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoplf+GGqjxMT9iSwXDVJ
8Ru6rBkvTdDmTsOG8flza06OnQn4TbnB9y5VkYsK6BEQxf5VAuI7Jhp8UeZhblCn
2FXgxVE0e182LA2P+S5Jpd7LQRb7A7UhNKr1gWIwHLkm2IbyZ9e+JQIz9/zbXcjN
24iuf2//Ll+JoJ04/2tAooYNRp0dorq/gMN/OmV3JTcBplxBHPJ9klGvw/JTdAbi
vGmiQSG4UYOFw3ThIok7SGBQSccZ0xXFRUvtUxtDynVuLcFK10n6pCy2cJRzcU9d
uXgkBYsXeKyV8J5iBatNg7PAu6AuPaMyhK/vxnVXCW7pgnIWPeKSaN3PiXE0WHi3
pQIDAQAB
-----END PUBLIC KEY-----`;
